import { call, put, takeEvery } from 'redux-saga/effects';
import {
  UPDATE_BUSINESS_REVENUE,
  UPDATE_BUSINESS_START_YEAR,
} from 'actions/business/constants';
import * as api from 'api/business';
import { getProfile } from 'api/profile';
import * as action from 'actions';
import * as actionNotification from 'actions/notifications';
import * as actionBusiness from 'actions/business';
import * as clevertapBusinessIndex from 'clevertap/business/index';

export function* updateBusinessRevenueSaga(request) {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  try {
    yield call(api.updateBusinessRevenueApi, request.payload);
    const profile = yield call(getProfile);
    const { data } = profile;
    const { email } = data;
    yield put(action.setAuthState(true, data));
    yield put(actionBusiness.setModalCompleteBusinessProfile(true));
    clevertapBusinessIndex.onUpdateBusinessRevenue(email);
  } catch (error) {
    yield put(actionNotification.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
    yield put(action.sendingRequest(false));
  }
}

export function* updateBusinessSstartSaga(request) {
  yield put(action.sendingRequest(true));
  yield put(action.showProgressBar());
  try {
    yield call(api.updateBusinessSstartApi, request.payload);
    const profile = yield call(getProfile);
    const { data } = profile;
    const { email } = data;
    yield put(action.setAuthState(true, data));
    clevertapBusinessIndex.onUpdateBusinessStartYear(email);
    yield put(actionBusiness.setModalCompleteBusinessProfile(true));
  } catch (error) {
    yield put(actionNotification.error(error.message));
  } finally {
    yield put(action.hideProgressBar());
    yield put(action.sendingRequest(false));
  }
}

export default function* saga() {
  yield takeEvery(UPDATE_BUSINESS_REVENUE, updateBusinessRevenueSaga);
  yield takeEvery(UPDATE_BUSINESS_START_YEAR, updateBusinessSstartSaga);
}
